<template>
  <v-banner class="subscription-banner" lines="one">
    <template v-slot:prepend>
      <v-icon color="warning" class="subscription-banner__icon"> mdi-wallet-membership </v-icon>
    </template>
    <v-banner-text class="subscription-banner__text">Vous n'avez actuellement aucun abonnement actif</v-banner-text>
    <template v-slot:actions>
      <v-btn
        color="primary"
        variant="text"
        @click="openCustomerPortal"
        v-if="hasSubscription"
        class="subscription-banner__button"
      >
        {{ isLoading ? "Chargement en cours..." : "Ouvrir mon portail d'abonnement" }}
      </v-btn>
      <v-btn
        color="primary"
        variant="text"
        :to="{ name: 'subscription' }"
        v-if="!hasSubscription"
        class="subscription-banner__button"
      >
        Devenir membre
      </v-btn>
    </template>
  </v-banner>
</template>

<script>
  import { auth, functions } from "@/firebase";
  export default {
    data() {
      return {
        isLoading: false,
        hasSubscription: false,
      };
    },
    async mounted() {
      this.isLoading = true;
      await this.customerHasSubscription();
      this.isLoading = false;
    },
    methods: {
      async customerHasSubscription() {
        const customerEmail = auth.currentUser.email;
        const customerHasSubscription = functions.httpsCallable("stripeIsCustomerHasSubscription");
        const { data } = await customerHasSubscription({ email: customerEmail });
        this.hasSubscription = data.hasSubscription;
      },
      async openCustomerPortal() {
        this.isLoading = true;
        const functionRef = functions.httpsCallable("stripeCreatePortalSession");
        const { data } = await functionRef({ returnUrl: window.location.origin });
        window.location.assign(data.url);
        this.isLoading = false;
      },
    },
  };
</script>

<style scoped>
  .subscription-banner {
    width: 100%;
    padding: 6px 8px;
    min-height: 40px;
  }

  .subscription-banner :deep(.v-banner__prepend) {
    margin-right: 6px;
    padding-right: 0;
  }

  .subscription-banner :deep(.v-banner__actions) {
    margin-left: 6px;
    padding-left: 0;
  }

  .subscription-banner__icon {
    font-size: 18px;
  }

  .subscription-banner__text {
    display: block;
    line-height: 1.15;
    font-size: 0.84rem;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  .subscription-banner__button {
    min-width: 0;
  }

  @media (max-width: 600px) {
    .subscription-banner {
      padding: 4px 6px;
      min-height: 34px;
    }

    .subscription-banner__icon {
      font-size: 16px;
      margin-right: 4px;
    }

    .subscription-banner__text {
      font-size: 0.76rem;
      line-height: 1.1;
      padding-right: 2px;
    }

    .subscription-banner__button {
      font-size: 0.72rem;
      padding-left: 4px;
      padding-right: 4px;
      min-height: 28px;
      margin-left: 0;
    }
  }
</style>
